'use client'
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/tag.ts
var TAG_QUERY = `
 title
 subtitle
 slug
 id
 background{${IMAGE_QUERY}}
 icon{${IMAGE_QUERY}}
`;

export {
  TAG_QUERY
};
//# sourceMappingURL=chunk-MWW3YBFP.mjs.map